/* Zaineer product gallery (mobile / tablet layout)
 * - dots under the main image
 * - "Tap to expand" label
 * - full-screen viewer with thumbnails, arrows, swipe, pinch zoom and double-tap zoom
 * Styles: assets/zaineer-gallery.css
 */
(function () {
  'use strict';

  var TEXT_EXPAND = 'Tap to expand';
  var TEXT_ZOOM = 'Pinch out to zoom';
  var MAX_SCALE = 4;

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function isVisible(node) {
    if (node.classList.contains('media-hidden')) return false;
    return window.getComputedStyle(node).display !== 'none';
  }

  /* ---------------------------------------------------------
     Full-screen viewer (one shared instance)
     --------------------------------------------------------- */
  var lb = null;

  function buildLightbox() {
    if (lb) return lb;
    var root = el('div', 'zg-lightbox');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Product images');

    var close = el('div', 'zg-lb-close', '\u00d7');
    close.setAttribute('role', 'button');
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('tabindex', '0');

    var stage = el('div', 'zg-lb-stage');
    var img = el('img', 'zg-lb-img');
    img.alt = '';
    var prev = el('div', 'zg-lb-nav zg-lb-prev', '\u2039');
    prev.setAttribute('role', 'button');
    prev.setAttribute('aria-label', 'Previous image');
    var next = el('div', 'zg-lb-nav zg-lb-next', '\u203a');
    next.setAttribute('role', 'button');
    next.setAttribute('aria-label', 'Next image');
    var hint = el('div', 'zg-lb-hint', TEXT_ZOOM);
    stage.appendChild(img);
    stage.appendChild(prev);
    stage.appendChild(next);
    stage.appendChild(hint);

    var thumbs = el('div', 'zg-lb-thumbs');

    root.appendChild(close);
    root.appendChild(stage);
    root.appendChild(thumbs);
    document.body.appendChild(root);

    lb = {
      root: root, stage: stage, img: img, prev: prev, next: next, hint: hint, thumbs: thumbs,
      items: [], index: 0, scale: 1, tx: 0, ty: 0, onClose: null
    };

    close.addEventListener('click', closeLightbox);
    prev.addEventListener('click', function (e) { e.stopPropagation(); show(lb.index - 1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); show(lb.index + 1); });
    root.addEventListener('click', function (e) {
      if (e.target === root) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.root.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') show(lb.index - 1);
      if (e.key === 'ArrowRight') show(lb.index + 1);
    });

    bindGestures();
    return lb;
  }

  function applyTransform() {
    lb.img.style.transform = 'translate3d(' + lb.tx + 'px,' + lb.ty + 'px,0) scale(' + lb.scale + ')';
  }

  function resetZoom() {
    lb.scale = 1;
    lb.tx = 0;
    lb.ty = 0;
    applyTransform();
  }

  function clampPan() {
    var maxX = Math.max(0, (lb.img.offsetWidth * lb.scale - lb.stage.clientWidth) / 2);
    var maxY = Math.max(0, (lb.img.offsetHeight * lb.scale - lb.stage.clientHeight) / 2);
    lb.tx = Math.min(maxX, Math.max(-maxX, lb.tx));
    lb.ty = Math.min(maxY, Math.max(-maxY, lb.ty));
  }

  function show(i) {
    var total = lb.items.length;
    if (!total) return;
    if (i < 0) i = total - 1;
    if (i >= total) i = 0;
    lb.index = i;
    resetZoom();
    var item = lb.items[i];
    lb.img.src = sized(item.src, 1600);
    lb.img.alt = item.alt || '';
    var nodes = lb.thumbs.children;
    for (var n = 0; n < nodes.length; n++) {
      nodes[n].classList.toggle('is-active', n === i);
    }
    var active = nodes[i];
    if (active) {
      var left = active.offsetLeft - (lb.thumbs.clientWidth - active.offsetWidth) / 2;
      if (lb.thumbs.scrollTo) {
        lb.thumbs.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        lb.thumbs.scrollLeft = left;
      }
    }
  }

  function openLightbox(items, index, onClose) {
    buildLightbox();
    lb.items = items;
    lb.onClose = onClose || null;
    lb.thumbs.innerHTML = '';
    items.forEach(function (item, i) {
      var t = el('div', 'zg-lb-thumb');
      t.setAttribute('role', 'button');
      t.setAttribute('aria-label', 'Image ' + (i + 1));
      var ti = el('img');
      ti.src = sized(item.src, 200);
      ti.alt = '';
      ti.loading = 'lazy';
      t.appendChild(ti);
      t.addEventListener('click', function (e) { e.stopPropagation(); show(i); });
      lb.thumbs.appendChild(t);
    });
    var single = items.length < 2;
    lb.prev.hidden = single;
    lb.next.hidden = single;
    lb.thumbs.style.display = single ? 'none' : '';
    lb.root.classList.add('is-open');
    document.documentElement.classList.add('zg-lock');
    show(index);
    lb.hint.classList.remove('is-show');
    void lb.hint.offsetWidth;
    lb.hint.classList.add('is-show');
  }

  function closeLightbox() {
    if (!lb) return;
    lb.root.classList.remove('is-open');
    document.documentElement.classList.remove('zg-lock');
    resetZoom();
    lb.img.removeAttribute('src');
    if (typeof lb.onClose === 'function') lb.onClose(lb.index);
  }

  function distance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function bindGestures() {
    var stage = lb.stage;
    var startDist = 0, startScale = 1;
    var startX = 0, startY = 0, startTx = 0, startTy = 0;
    var moved = false, pinching = false, lastTap = 0;

    stage.addEventListener('touchstart', function (e) {
      if (e.target.closest('.zg-lb-nav')) return;
      if (e.touches.length === 2) {
        pinching = true;
        startDist = distance(e.touches);
        startScale = lb.scale;
      } else if (e.touches.length === 1) {
        pinching = false;
        moved = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startTx = lb.tx;
        startTy = lb.ty;
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (e.target.closest('.zg-lb-nav')) return;
      if (e.touches.length === 2 && startDist > 0) {
        e.preventDefault();
        lb.scale = Math.min(MAX_SCALE, Math.max(1, startScale * distance(e.touches) / startDist));
        clampPan();
        applyTransform();
      } else if (e.touches.length === 1 && !pinching) {
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
        if (lb.scale > 1) {
          e.preventDefault();
          lb.tx = startTx + dx;
          lb.ty = startTy + dy;
          clampPan();
          applyTransform();
        }
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.target.closest('.zg-lb-nav')) return;
      if (pinching) {
        if (e.touches.length === 0) pinching = false;
        if (lb.scale < 1.05) resetZoom();
        return;
      }
      var touch = e.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (lb.scale === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        show(lb.index + (dx < 0 ? 1 : -1));
        return;
      }
      if (!moved) {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (lb.scale > 1) {
            resetZoom();
          } else {
            lb.scale = 2.5;
            clampPan();
            applyTransform();
          }
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }
    }, { passive: true });

    /* Mouse: click on the empty area closes, double click zooms */
    stage.addEventListener('click', function (e) {
      if (e.target === stage && lb.scale === 1 && !('ontouchstart' in window)) closeLightbox();
    });
    stage.addEventListener('dblclick', function () {
      if (lb.scale > 1) {
        resetZoom();
      } else {
        lb.scale = 2.5;
        applyTransform();
      }
    });
  }

  /* ---------------------------------------------------------
     On-page gallery: dots + "Tap to expand"
     --------------------------------------------------------- */
  function setupGallery(root) {
    var swiperEl = root.querySelector('.bls__swiper-gallery-mobile');
    if (!swiperEl || swiperEl.__zgReady) return;
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    swiperEl.__zgReady = true;

    var list = swiperEl.closest('.product__media-list') || swiperEl.parentNode;
    var hint = el('div', 'zg-expand-hint', TEXT_EXPAND);
    list.appendChild(hint);
    var dots = el('div', 'zg-dots');
    list.parentNode.insertBefore(dots, list.nextSibling);

    var signature = '';

    function allSlides() {
      return Array.prototype.slice.call(wrapper.children).filter(function (s) {
        return s.classList.contains('swiper-slide');
      });
    }

    function visibleSlides() {
      return allSlides().filter(isVisible);
    }

    function imageItems() {
      var items = [];
      visibleSlides().forEach(function (slide) {
        var media = slide.querySelector('.bls__prod-media');
        if (!media || !media.classList.contains('image')) return;
        var src = media.getAttribute('data-src');
        if (!src) return;
        var image = media.querySelector('img');
        items.push({ slide: slide, src: src, alt: image ? image.alt : '' });
      });
      return items;
    }

    function goTo(slide) {
      var swiper = swiperEl.swiper;
      var index = allSlides().indexOf(slide);
      if (swiper && index > -1) swiper.slideTo(index);
    }

    function refresh() {
      var slides = visibleSlides();
      var sig = slides.map(function (s) {
        return s.getAttribute('data-media-id') || s.getAttribute('data-position') || '';
      }).join('|');
      if (sig !== signature) {
        signature = sig;
        dots.innerHTML = '';
        slides.forEach(function (slide, i) {
          var dot = el('span', 'zg-dot');
          dot.setAttribute('role', 'button');
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.addEventListener('click', function () { goTo(slide); });
          dots.appendChild(dot);
        });
        dots.hidden = slides.length < 2;
      }
      var activeIndex = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('swiper-slide-active')) activeIndex = i;
      });
      for (var n = 0; n < dots.children.length; n++) {
        dots.children[n].classList.toggle('is-active', n === activeIndex);
      }
      var activeSlide = slides[activeIndex];
      var activeMedia = activeSlide && activeSlide.querySelector('.bls__prod-media');
      hint.style.display = activeMedia && activeMedia.classList.contains('image') ? '' : 'none';
    }

    var timer = null;
    function queueRefresh() {
      if (timer) return;
      timer = window.setTimeout(function () {
        timer = null;
        refresh();
      }, 60);
    }

    new MutationObserver(queueRefresh).observe(wrapper, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });

    swiperEl.addEventListener('click', function (e) {
      var slide = e.target.closest('.swiper-slide');
      if (!slide || !wrapper.contains(slide)) return;
      if (e.target.closest('button, a, video, iframe, model-viewer, .swiper-arrow')) return;
      var items = imageItems();
      var index = -1;
      items.forEach(function (item, i) {
        if (item.slide === slide) index = i;
      });
      if (index < 0) return;
      e.preventDefault();
      openLightbox(items, index, function (lastIndex) {
        if (items[lastIndex]) goTo(items[lastIndex].slide);
      });
    });

    refresh();
    window.setTimeout(refresh, 600);
    window.setTimeout(refresh, 2000);
  }

  function init() {
    var roots = document.querySelectorAll('.product__media-mobile');
    for (var i = 0; i < roots.length; i++) setupGallery(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 100);
  });
})();
